/**
 * 球界特殊域名下载页（QJBG 落地页）
 */
import { getCurrentHost } from "@/util/lm-download";

export const QJ_DOWNLOAD_HOSTS = ["qjtyg.com"];

/** 球界落地页友盟 / cnzz */
export const QJ_CNZZ_SRC = "https://v1.cnzz.com/z.js?id=1281497884&async=1";

export function isQjDownloadHost(host = getCurrentHost()) {
  if (!host) return false;
  return QJ_DOWNLOAD_HOSTS.includes(host);
}
